export function nameFormat(name) {
    return name
        .trim()
        .split(/\s+/)
        .map((str) => str[0].toUpperCase() + str.slice(1).toLowerCase())
        .join(' ');
}
